define('app/models/paginacao',['require','backbone'],function(require){
    var Backbone = require('backbone');
    return new Backbone.Model({
        page: 1,
        rows: 3200
    });
});
